import { Button, Stack, Typography } from '@packages/shared';
import { LoadReload32 } from '@packages/themes/icons';

export const ResponsiveHeaderErrorFallback = () => (
  <Stack direction="row" alignItems="center" gap={2} padding={1} bgcolor="error.light">
    <Typography variant="body1">Error</Typography>
    <Button
      variant="outlined"
      onClick={() => {
        window.location.reload();
      }}
      aria-label="Reload page"
    >
      <LoadReload32 />
    </Button>
  </Stack>
);
